<script>
import i18nValidate from "@/i18ns/vi/i18nValidate";
export default {
  name: "msBaseComponent",
  props: {
    readonly: {
      default: false,
      type: Boolean,
    },
    //rule dùng để validate control
    //Created by LTDAT(22.06.2020)
    rules: {
      type: String,
      default: null,
    },
    /**
     * Tên của control phục vụ việc hiện thị message cho validate
     * Created by LTDAT(22.06.2020)
     */
    name: {
      default: null,
      type: String,
    },
    /**
     * NNLAM 22/03/2021
     * prop kiểu hàm cho phép custom validate trên cell grid
     */
    customValidateRules: {
      type: Function,
      default: null,
    },
    /**
     * thuộc tính readOnly cho các form sử dụng có thể khai báo trực tiếp
     */
    readOnly: {
      type: Boolean,
      default: false,
    },

    /**
     * Thuộc tính disable control (bổ sung lên đây để dùng chung cho toàn bộ các component)
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    const me = this;
  },
  mounted() {
    const me = this;
  },
  data() {
    return {
      errorProvider: {},
    };
  },
  computed: {
    isReadOnly: function () {
      return this.readOnly || this.readOnlyState;
    },
    isDisabled: function () {
      return this.disabled || this.disabledState;
    },
  },
  methods: {
    setPlacementTooltip() {
      const me = this;
      let placement = "bottom";
      let pos = me.$el ? me.$el.getBoundingClientRect() : {},
        windowWidth =
          window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (pos.right > windowWidth - 200) {
        placement = "bottom-end";
      }
      return placement;
    },
    getErrorProvider() {
      return this.errorProvider;
    },

    /**
     * Validate component sự kiện validate control
     * Created by LTDAT(22.06.2020)
     * mdofiy by ĐVThi 05/02/2020: Đáp ứng validate không cho phép chọn đối tượng cha
     * modify by nnlam 22/03/2021: custom lại trong trường hợp component là cell grid
     *
     *  */
    validate(editor) {
      const me = this;
      if (me.disabled) {
        me.errorProvider = {};
        return me.errorProvider;
      }
      let listRules = [],
        rulesValidate = null,
        ret = false,
        colRules = null,
        colField = null,
        isCell = false,
        titleCell = null,
        thisEditor = null;
      //check xem editor là msinput/msnumber... (gọi là control gốc) hay là mscellInput/msCellNumber.... (gọi chung là cell grid)
      if (editor && editor.col) {
        colRules = editor.col.rules;
        colField = editor.col.dataField;
        titleCell = editor.col.caption;
        isCell = true;
        if (editor.$refs.editor) {
          thisEditor = editor.$refs.editor.querySelector(".ms-editor");
          if (thisEditor && thisEditor.getVueInstance()) {
            thisEditor = thisEditor.getVueInstance();
            thisEditor.$data.col = editor.col;
          }
        }
      }
      if (me.rules || colRules) {
        listRules = me.rules ? me.rules.split("|") : colRules.split("|");
        listRules.add("specialinput");
      }
      for (let i = 0; i < listRules.length; i++) {
        let value = me.value;
        if (editor) {
          //ưu tiên lấy value theo control gốc
          if (editor.hasOwnProperty("internalValue")) {
            value = editor.internalValue;
          }
          //nếu không có value thì => đây là edit trên cell grid
          if (!value) {
            if (editor.dataRow) {
              value = editor.dataRow[colField];
            }
          }
        }
        ret = !me.validateRule(listRules[i], me.internalText || value, editor);
        if (ret) {
          rulesValidate = listRules[i];
          break;
        }
      }

      if (ret) {
        let label = me.name || me.title || titleCell || me.getValidateName();
        if (editor && editor.customMessage) {
          me.errorProvider.message = editor.customMessage;
        } else {
          if (i18nValidate.messages[rulesValidate]) {
            me.errorProvider.message = i18nValidate.messages[rulesValidate](label);
          }
        }
        /*
         * Pvduy 18/03/2021: thêm đoạn xử lý custom lại message thông báo lỗi.
         */
        if (
          me.customWarring != null &&
          me.customWarring.rules == rulesValidate &&
          me.customWarring.mes != ""
        ) {
          me.errorProvider.message = me.customWarring.mes;
        }
        let element = null;
        if (me.$refs) {
          element = me.$refs.input;
        } else if (thisEditor && thisEditor.$refs) {
          element = thisEditor.$refs.input;
        } else {
          element = null;
        }
        me.errorProvider.isValid = true;
        let placement = me.setPlacementTooltip();
        me.errorProvider.placementTooltip = placement;
        me.errorProvider.rules = rulesValidate;
        me.errorProvider.element = element;
        //nếu là cell grid thì cần gán lại errorProvider cho control gốc để hiển thị validate
        if (isCell) {
          if (thisEditor) {
            thisEditor.errorProvider = editor.errorProvider;
          }
        }
      } else {
        me.errorProvider = {};
      }
      return me.errorProvider;
    },

    /**
     * Nếu control không khai báo name để hiển thị thông tin lỗi validate -> up parent find label
     */
    getValidateName() {
      let fn = function (el, c) {
        if (!el || c > 10) {
          return null;
        }

        let labelEl = el.querySelector("label");
        if (labelEl) {
          return (labelEl.innerText || "").replace("*", "");
        }

        return fn(el.parentNode, c + 1);
      };

      return fn(this.$el, 0);
    },

    validateRule(rule, value, editor) {
      const me = this;

      switch (rule) {
        case "forceSelection":
          return me.validateForceSelection(value, editor);
          break;

        case "notSelectParent":
          return me.validateNotSelectParent(value, editor);
          break;
        case "required":
          return me.validateRequired(value);
          break;
        case "taxCode":
          return me.validateTaxCode(value);
          break;
        case "taxCodeMaxLength":
          return me.validateTaxCodeLength(value);
          break;
        case "budget":
          return me.validateBudgetCode(value);
          break;
        case "budgetMaxLength":
          return me.validateBudgetCodeLength(value);
          break;
        case "phoneEmail":
          return me.validatePhoneEmail(value);
          break;
        case "phone":
          return me.validatePhone(value);
          break;
        case "email":
          return me.validateEmail(value);
          break;
        case "password":
          return me.validatePassword(value);
          break;
        // pvduy 22/03/2021 thêm đoạn xử lý validate giá trị khác 0
        case "diffierentZero":
          return me.validatediffierentZero(value);
          break;
        case "cmt":
          if (me.validateCMT(value) == true || me.validateCMT_12(value) == true) {
            return true;
          } else {
            return false;
          }
          break;
        case "cccd":
          return me.validateCCCD(value);
          break;
        case "number":
          return me.validateNumberText(value);
          break;
        case "integer":
          return me.validateNumberPositiveBigger0(value);
          break;
        case "passport":
          return me.validatePassport(value);
          break;
        case "specialinput":
          return me.validateSpecialInput(value);
          break;
        case "specialCharacters":
          return me.validateSpecialCharacters(value);
          break;
        case "greaterThanCurrentDate":
          return me.validateGreaterThanCurrentDate(value);
          break;
        default:
          if (typeof me.customValidateRules == "function") {
            return me.customValidateRules(rule, value, editor);
          } else {
            return true;
          }
          break;
      }
    },
    /*
     * validate số CMT 9 số
     */
    validateCMT(value) {
      try {
        let oRegex = /^\s*-?[0-9]{9}\s*$/;
        let result = value;
        if (!oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },

    /*
     * validate số CMT 12 số
     */
    validateCMT_12(value) {
      try {
        let oRegex = /^\s*-?[0-9]{12}\s*$/;
        let result = value;
        if (!oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    /*
     * validate số CCCD
     */
    validateCCCD(value) {
      try {
        let oRegex = /^\s*-?[0-9]{12}\s*$/;
        let result = value;
        if (!oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    /*
     * validate số cho control text
     */
    validateNumberText(value) {
      try {
        let oRegex = /^\s*-?[0-9]{1,20}\s*$/;
        let result = value;
        if (!oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    /*
     * validate khác không
     * pvduy 22/03/2021
     */
    validatediffierentZero(value) {
      const me = this;
      if (value == undefined || value === null || value === "" || value <= 0) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * UpdatedBy: TSTung - 20/12/2021
     * Validate required
     */
    validateRequired(value) {
      if (value && typeof value == "string") value = value.trim();
      return !!value;
    },

    //Validate mã ngân sách
    validateBudgetCode(value) {
      try {
        let rex = /^[0-9]{7,10}$/;
        if (value.length < 7 || value.length > 10) {
          return true;
        } else {
          return rex.test(value);
        }
      } catch (e) {
        return false;
      }
    },

    // Validate mã ngân sách max length
    validateBudgetCodeLength(value) {
      try {
        let rex = /^[0-9]{7,10}$/;
        return rex.test(value);
      } catch (e) {
        return false;
      }
    },

    //Validate mã số thuế
    validateTaxCode(value) {
      try {
        let oRegex = /^[A-Za-z0-9-]+$/;
        if (oRegex.test(value)) {
          let arrcode = [],
            lengthCode = value.length;
          for (let i = 0; i < lengthCode; i++) {
            arrcode.push(value[i]);
          }

          // let intTemp =
          //   31 * parseFloat(arrcode[0]) +
          //   29 * parseFloat(arrcode[1]) +
          //   23 * parseFloat(arrcode[2]) +
          //   19 * parseFloat(arrcode[3]) +
          //   17 * parseFloat(arrcode[4]) +
          //   13 * parseFloat(arrcode[5]) +
          //   7 * parseFloat(arrcode[6]) +
          //   5 * parseFloat(arrcode[7]) +
          //   3 * parseFloat(arrcode[8]);

          // if (!(parseFloat(arrcode[9]) === 10 - (intTemp % 11))) {
          //   return false;
          // }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },

    //Validate chiều dài mã số thuế
    validateTaxCodeLength(value) {
      try {
        let oRegex = /^[A-Za-z0-9-]{9,15}$/;
        if (oRegex.test(value)) {
          let arrcode = [],
            lengthCode = value.length;
          for (let i = 0; i < lengthCode; i++) {
            arrcode.push(value[i]);
          }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    validatePhoneEmail(value) {
      try {
        return this.validatePhone(value) || this.validateEmail(value);
      } catch (e) {
        return false;
      }
    },
    /**
     * Check ký tự đặc biệt
     * CreatedBy: tmquy (15/12/2021)
     */
    validateSpecialCharacters(value) {
      try {
        let oRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        if (!oRegex.test(String(value))) {
          return true;
        }
      } catch (e) {
        return true;
      }
      return false;
    },

    /**
     * Cập nhật validate số điện thoại bàn
     * UpdatedBy: dbhuan 18/03/2022
     */
    validatePhone(value) {
      try {
        let oRegex =
          /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[123456789])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;

        // regex cho số điện thoại bàn
        // bao gồm đủ mã vùng cho 63 tỉnh/thành
        let otherRegex =
          /^0(296|254|209|204|291|222|275|256|274|271|252|290|292|206|236|262|261|215|251|277|269|226|24|239|220|225|293|28|221|258|297|260|213|263|205|214|272|228|238|259|229|257|232|235|255|203|233|299|212|276|227|208|237|234|273|294|207|270|216|211|210|218)([0-9]{7,8})$/;
        let result = value;
        if (!oRegex.test(result.trim()) && !otherRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },

    validateEmail(value) {
      try {
        // let oRegex = /[a-z0-9_\.]{0,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/;
        let oRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        let result = value.toLowerCase();
        if (result && !oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    validatePassword(value) {
      const me = this;
      let lengthPass = false;
      if (value && value.length >= 8) {
        lengthPass = true;
      }
      let textPass = false;
      let upcasePass = false;
      let lowercasePass = false;
      if (value && /[^A-Z]/g.test(value)) {
        upcasePass = true;
      }
      if (value && /[^a-z]/g.test(value)) {
        lowercasePass = true;
      }
      if (upcasePass && lowercasePass) {
        textPass = true;
      }
      let numberPass = false;
      if (value && /[^0-9]/g.test(value)) {
        numberPass = true;
      }
      me.errorProvider.lengthPass = lengthPass;
      me.errorProvider.textPass = textPass;
      me.errorProvider.numberPass = numberPass;
      return lengthPass && textPass && numberPass;
    },
    validateForceSelection(value, editor) {
      const me = this;
      if (editor && editor.internalText) {
        let dataSource = editor.internalDataSource;

        //nếu là binding thì trả về true
        if (editor.internalText === editor.initText && dataSource.length === 0) {
          return true;
        }

        if (dataSource && dataSource.length > 0) {
          let valueText = editor.internalText;
          let typeAheadPointer = editor.filterIndexItemByText(valueText);
          if (typeAheadPointer != null && typeAheadPointer != undefined && typeAheadPointer >= 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      return true;
    },
    /**
     * ĐVThi 05/02/2020: Validate bắt buộc chọn con, không được chọn cha
     */

    validateNotSelectParent(value, editor) {
      if (editor) {
        let item = editor.internalSelectedItem;
        if (item && item.hasOwnProperty("isParent") && item["isParent"]) {
          return false;
        }
      }
      return true;
    },
    applyValidate(message) {
      const me = this;
      if (message) {
        me.errorProvider.message = message;
        me.errorProvider.isValid = true;
        let placement = me.setPlacementTooltip();
        me.errorProvider.placementTooltip = placement;
        me.errorProvider.element = me.$refs.input;
      } else {
        me.errorProvider = {};
      }
    },
    /**
     * Số nguyên dương lớn hơn 0
     * CreatedBy: tmquy (19/08/2021)
     */
    validateNumberPositiveBigger0(value) {
      value = String(value);
      try {
        let oRegex = /^\+?[1-9]\d*$/;
        let result = value;
        if (!oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    /**
     * Validate passport code
     * CreatedBy: tmquy (06/10/2021)
     */
    validatePassport(value) {
      try {
        let oRegex = /^(?!^0+$)[a-zA-Z0-9]{3,20}$/;
        if (!oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },

    /**
     * Check ký tự đặc biệt
     * CreatedBy: tmquy (15/12/2021)
     */
    validateSpecialInput(value) {
      try {
        let oRegex = /<(|\/|[^\/>][^>]+|\/[^>][^>]+)>/;
        if (!oRegex.test(String(value))) {
          return true;
        }
      } catch (e) {
        return true;
      }
      return false;
    },

    /**
     * Kiểm tra xem ngày có lớn hơn ngày hiện tại không
     * CreatedBy: 10/06/2025
     */
    validateGreaterThanCurrentDate(value) {
      try {
        if (!value) return true;

        // Nếu giá trị là string, chuyển đổi thành Date
        const dateValue = value instanceof Date ? value : new Date(value);

        // Lấy ngày hiện tại (đặt giờ, phút, giây về 0 để chỉ so sánh ngày)
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        // Đặt giờ, phút, giây của ngày cần so sánh về 0
        const compareDate = new Date(dateValue);
        compareDate.setHours(0, 0, 0, 0);

        // So sánh ngày đã chọn với ngày hiện tại
        return compareDate > currentDate;
      } catch (e) {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
